import ajax from "../../lib/appfuse-react/core/ajax";
import downloader from "../../lib/appfuse-react/core/downloader";

const utilService = {
    getByUrl: async (url, params, options) => {
        const response = await ajax.get(url, params, options);
        return response.data;
    },
    postByUrl: async (url, data) => {
        const response = await ajax.post(url, data);
        return response.data;
    },
    patchByUrl: async (url, data) => {
        const response = await ajax.patch(url, data);
        return response.data;
    },
    deleteByUrl: async (url) => {
        await ajax.delete(url);
    },
    downloadFileByUrl: async (url, params, filename) => {
        await downloader.save(url, params, filename);
    },
    findAllCounties: async () => {
        const response = await ajax.get('counties/findAll');
        return response.data;
    },
    validateAddress: async (data) => {
        await ajax.post('addresses/validate', data);
    }
}

export default utilService;